import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PublicLayout } from "../components/PublicLayout";

const TERMS = [
  ["1. Acceptance of Terms", "By accessing or using the Campus Energy Monitor dashboard (the \"Service\"), you agree to be bound by these Terms & Conditions. If you do not agree, you may not use the Service. This Service is provided as part of an academic Final Year Project at the Cape Peninsula University of Technology (CPUT)."],
  ["2. Use of the Service", "The Service is intended for monitoring and controlling IoT energy-metering hardware. You agree to use it only for lawful purposes and not to interfere with its operation, attempt unauthorized access, or disrupt connected devices."],
  ["3. Accounts & Security", "You are responsible for maintaining the confidentiality of your account credentials and for all activity under your account. Notify the administrator immediately of any unauthorized use. Passwords are stored using industry-standard bcrypt hashing."],
  ["4. Device Control Disclaimer", "Commands sent through the Service control physical electrical equipment. You acknowledge that you operate this hardware at your own risk and that the developer is not liable for any damage, injury, or loss arising from device operation."],
  ["5. Data & Telemetry", "Sensor telemetry and snapshots may be transmitted via HiveMQ Cloud and stored locally in your browser or in project databases for demonstration purposes. No guarantee is made regarding data accuracy, retention, or availability."],
  ["6. Intellectual Property", "All designs, code, and content remain the intellectual property of Henock Mukonkole unless otherwise stated. You may not reproduce or redistribute the Service without permission."],
  ["7. Limitation of Liability", "The Service is provided \"as is\" without warranties of any kind. To the maximum extent permitted by law, the developer shall not be liable for any indirect, incidental, or consequential damages."],
  ["8. Changes to Terms", "These Terms may be updated periodically. Continued use of the Service after changes constitutes acceptance of the revised Terms."],
  ["9. Contact", "For questions regarding these Terms, contact Henockmukonkole62@gmail.com."],
];

const PRIVACY = [
  ["1. Information We Collect", "When you create an account we collect your name, email address, and a securely hashed password. The Service also processes IoT telemetry (voltage, current, power, temperature, air quality) and optional camera snapshots."],
  ["2. How We Use Information", "Account data is used solely to authenticate you and provide access to the dashboard. Telemetry is used to render live readings, charts and alerts. Snapshots are stored in your browser's local storage by default."],
  ["3. Cookies & Tokens", "We use httpOnly cookies and/or browser local storage to keep you signed in. These are essential for authentication and are not used for advertising or third-party tracking."],
  ["4. Data Storage", "User accounts are stored in a MongoDB database. Passwords are never stored in plain text; they are hashed with bcrypt. Telemetry shown in the preview is simulated and not personally identifiable."],
  ["5. Third-Party Services", "The Service may integrate with HiveMQ Cloud (MQTT), Grafana Cloud, ThingSpeak and Google Sheets. Their use of data is governed by their own privacy policies."],
  ["6. Data Retention", "You may delete your locally stored snapshots at any time from the Gallery. Account deletion requests can be made by contacting the administrator."],
  ["7. Your Rights", "You have the right to access, correct, or delete your personal data. Contact Henockmukonkole62@gmail.com to exercise these rights."],
  ["8. Children's Privacy", "The Service is not directed at children under 13 and we do not knowingly collect their data."],
  ["9. Contact", "For privacy concerns, contact Henockmukonkole62@gmail.com."],
];

export default function Legal() {
  const [tab, setTab] = useState("terms");

  const sections = tab === "terms" ? TERMS : PRIVACY;
  const heading  = tab === "terms" ? "Terms & Conditions" : "Privacy Policy";

  return (
    <PublicLayout>
      <section className="w-full px-4 sm:px-8 lg:px-12 py-16">
        <div className="max-w-[1400px] mx-auto">
          <span className="uppercase tracking-[0.2em] text-[10px] font-bold text-[var(--accent)]">Legal</span>
          <h1 className="font-heading font-black text-4xl tracking-tighter mt-2">{heading}</h1>
          <p className="text-sm text-[var(--t2)] mt-2 font-mono">Last updated: August 2026</p>

          <div className="flex gap-2 mt-6 border-b border-[var(--bd)] pb-0">
            {["terms", "privacy"].map((t) => (
              <button
                key={t}
                onClick={() => setTab(t)}
                className={`px-5 py-2.5 text-sm font-medium border-b-2 transition-colors capitalize ${
                  tab === t
                    ? "border-[var(--accent)] text-[var(--accent)]"
                    : "border-transparent text-[var(--t2)] hover:text-[var(--t1)]"
                }`}
              >
                {t === "terms" ? "Terms & Conditions" : "Privacy Policy"}
              </button>
            ))}
          </div>

          <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-x-12 gap-y-7">
            {sections.map(([t, b]) => (
              <div key={t}>
                <h2 className="font-heading font-bold text-lg">{t}</h2>
                <p className="text-sm text-[var(--t2)] mt-2 leading-relaxed">{b}</p>
              </div>
            ))}
          </div>

          <hr className="mt-14 border-0 border-t border-[var(--bd-strong)] opacity-60" />
          <div className="text-center mt-14">
            <h2 className="font-heading font-black text-2xl sm:text-3xl tracking-tight">Ready to explore the live system?</h2>
            <p className="text-[var(--t2)] mt-3 max-w-md mx-auto">Create an account and open the real-time dashboard in seconds.</p>
            <div className="flex flex-wrap justify-center gap-3 mt-6">
              <Link to="/register" className="inline-flex px-7 py-3 rounded-md bg-[var(--accent)] text-black font-semibold text-sm active:scale-95 transition-transform">Launch Dashboard</Link>
              <Link to="/about" className="inline-flex px-7 py-3 rounded-md border border-[var(--bd)] font-semibold text-sm hover:border-[var(--bd-strong)] transition-colors">Meet the Engineer</Link>
            </div>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
